import { useState, useEffect } from 'react';
import useDataBean from '../../../../core/services/dataBean/useDataBean';
import { _SalesContact, _SalesOrderState, _TransportServiceType } from '../../../../core/services/dataBean/EntityCatalogVdos';


interface Props {
    idSelector: number;
    onChange: any;
    label?: string;
    disable?: boolean;
}

export const TransportServiceType = ({ idSelector, onChange, label, disable }: Props) => {

    const { instance, lista, setLista } = useDataBean(_TransportServiceType)
    const [id, setID] = useState(null);

    useEffect(() => {
        setID(idSelector)
    }, [idSelector])

    useEffect(() => {
        getLista();
    }, [])

    const setValue = (e: any) => {
        setID(e);
        onChange(e);
    }

    const getLista = () => {

        instance.getTransportServiceType(null).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                }
            }
        ).catch(err => { console.log(err) })
    }

    return (
        <>
            <label>{label ?? "Tipo"}</label>
            <select disabled={disable} className="form-select" value={id} onChange={(e) => { setValue(parseInt(e.target.value)) }}>
                <option value={null}>...</option>
                {lista &&
                    lista.map((item: any, index: number) => {
                        return (
                            <option key={index} value={item.DataBeanProperties.Value} >{item.DataBeanProperties.Property}</option>
                        )
                    })
                }
            </select>
        </>
    )
}